import renderMathInElement from 'katex/contrib/auto-render';
import { useEffect, useRef, RefObject } from 'react';
import { katexRenderOption } from '../utils/katex';

const useMathTitleSetup = <T extends HTMLElement>(
    text: string,
    keyword?: string,
    trigger?: boolean
): RefObject<T> => {
    const elementRef = useRef<T>(null);

    useEffect(() => {
        if (elementRef.current) {
            renderMathInElement(elementRef.current, katexRenderOption);
        }
    }, [text, keyword, trigger]);

    return elementRef;
};

export default useMathTitleSetup;
